<template>
  <div class="clueCollect">
    <div class="clue-container">
      <div class="clue-title">
        <div class="clue-title-t">如您想购买二手机 请登记购机需求 即可参与抽奖</div>
        <div class="clue-title-b">*奖品需购机后领取</div>
      </div>
      <div class="content-region">
        <van-cell
          title="设备信息"
          required
          is-link
          :value="infoData ? infoData : '请选择'"
          :value-class="infoData ? 'selected' : ''"
          @click="infoShow = true"
        />
        <van-cell
          title="起重机类型"
          required
          is-link
          :value="subTypeName ? subTypeName : '请选择'"
          :value-class="subTypeName ? 'selected' : ''"
          @click="subTypeShow = true"
          v-show="typeId == 54"
        />
        <van-field
          :label="changeLable"
          required
          v-model="changeValue"
          type="digit"
          input-align="right"
          placeholder="请填写"
          v-show="typeId && typeId != 55"
          @blur="onBlurValue"
        >
          <template #extra>
            <p style="margin-left: 5px">{{ changeUnit }}</p>
          </template>
        </van-field>
        <van-cell
          title="工时要求"
          is-link
          :value="workHoursName ? workHoursName : '请选择'"
          :value-class="workHoursName ? 'selected' : ''"
          @click="hoursShow = true"
        />
        <van-cell
          title="年限要求"
          is-link
          :value="manufactureYearLimit ? manufactureYearLimit : '请选择'"
          :value-class="manufactureYearLimit ? 'selected' : ''"
          @click="yearShow = true"
        />
        <van-field label="预算" v-model="budget" type="digit" input-align="right" placeholder="请填写" @blur="onBlurBudget">
          <template #extra>
            <p style="margin-left: 5px">万</p>
          </template>
        </van-field>
        <van-cell
          title="预期购买时间"
          required
          is-link
          :value="expectPurchaseTime ? expectPurchaseTime : '请选择'"
          :value-class="expectPurchaseTime ? 'selected' : ''"
          @click="timeShow = true"
        />
        <van-field label="其他购车要求" type="textarea" autosize maxlength="50" v-model="otherRequire" input-align="right" placeholder="请填写" />
        <van-field label="您的姓名" v-model="userName" input-align="right" placeholder="请填写您的姓名" />
        <van-field label="联系方式" v-model="userPhone" type="tel" required input-align="right" placeholder="请填写您的联系方式" />
      </div>
      <van-image class="img-src" :src="img2" fit="fill" lazy-load show-loading />
      <van-image v-if="extSrc != 'dyapp'" class="img-src" :src="img3" fit="fill" lazy-load show-loading />
    </div>
    <div class="bottom-btn-style" v-if="showFooter">
      <van-image class="btn-style" :src="img4" fit="fill" @click.native="onCustomer" />
      <van-image class="btn-style" :src="img5" fit="fill" @click.native="onClueAdd" />
    </div>
    <van-popup v-model="infoShow" round position="bottom">
      <div class="device-title">设备信息</div>
      <van-tabs v-model="active" @click="changeTabs">
        <van-tab
          style="height: 550px; overflow-y: scroll"
          v-for="(item, index) in deviceList"
          :key="index"
          v-if="item.list.length != 0"
          :title="item.label"
        >
          <div class="list-search" v-if="active != 0">
            <van-search v-model="searchVal" clearable placeholder="请输入搜索关键词"></van-search>
          </div>
          <div
            :class="one.text == item.label ? 'list-item-selected list-item' : 'list-item'"
            v-if="one.text.toLowerCase().indexOf(searchVal.toLowerCase()) != -1"
            v-for="one in item.list"
            @click="chooseType(one, index)"
          >
            {{ one.text }}
          </div>
        </van-tab>
      </van-tabs>
    </van-popup>
    <van-popup v-model="hoursShow" round position="bottom">
      <van-picker show-toolbar title="工时要求" :columns="columnsHours" @confirm="onConfirmHour" @cancel="hoursShow = false" />
    </van-popup>
    <van-popup v-model="yearShow" round position="bottom">
      <van-picker show-toolbar title="年限要求" :columns="columnsYear" @confirm="onConfirmYear" @cancel="yearShow = false" />
    </van-popup>
    <van-popup v-model="subTypeShow" round position="bottom">
      <van-picker show-toolbar title="起重机类型" :columns="columnsSubType" @confirm="onConfirmSubType" @cancel="subTypeShow = false" />
    </van-popup>
    <van-popup v-model="timeShow" round position="bottom">
      <van-picker show-toolbar title="预期购买时间" :columns="columnsTime" @confirm="onConfirmTime" @cancel="timeShow = false" />
    </van-popup>
  </div>
</template>
<script>
import BigNumber from "bignumber.js"
export default {
  name: "clueCollect",
  components: {},
  data() {
    return {
      extSrc: "", //渠道来源
      img2: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-bg2.png",
      img3: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-bg3.png",
      img4: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-btn-left.png",
      img5: "https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-btn-right.png",
      infoShow: false, //设备信息
      infoData: "", //设备信息数据
      subTypeShow: false, //起重机类型
      subTypeName: "", //起重机类型数据
      columnsSubType: ["汽车起重机", "履带起重机", "塔式起重机"], //起重机类型列表
      hoursShow: false, //工时要求
      workHoursName: "", //工时要求数据
      columnsHours: ["不限", "2000小时以内", "5000小时以内"], //工时要求列表
      yearShow: false, //年限要求
      manufactureYearLimit: "", //年限要求数据
      columnsYear: ["不限", "3年以内", "5年以内"], //年限要求列表
      budget: "", //预算
      timeShow: false, //预期购买时间
      expectPurchaseTime: "", //预期购买时间数据
      columnsTime: ["1周内", "1个月内", "3个月内", "半年内"], //预期购买时间列表
      otherRequire: "", //其他购车要求
      userName: "", //姓名
      userPhone: "", //联系方式
      typeName: "", //类型名称
      typeId: "", //类型ID
      brandName: "", //品牌名称
      brandId: "", //品牌ID
      changeLable: "", //动态名称
      changeValue: "", //动态值
      changeUnit: "", //动态单位
      canClick: true, //防多次点击
      screenHeight: document.documentElement.clientHeight, //默认屏幕高度
      originHeight: document.documentElement.clientHeight,
      showFooter: true, //显示底部fixed
      active: 0,
      deviceList: [
        { label: "请选择", list: [] },
        { label: "请选择", list: [] }
      ],
      resultList: [], //选择结果
      searchVal: "" //搜索值
    }
  },
  created() {
    document.title = "买二手设备上云联二手机"
    let { extSrc, name, mobile } = this.$route.query
    this.extSrc = extSrc || "" //渠道来源
    this.userName = name || "" //链接传过来的姓名
    this.userPhone = mobile || "" //链接传过来的手机号
    this.getTypeBrandList() //设备信息
    this.gatLog() //用户活动统计数据
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        //实时屏幕高度
        this.screenHeight = document.documentElement.clientHeight
      })()
    }
  },
  methods: {
    getTypeBrandList() {
      this.$api.typeBrandList({ includeType: true }).then((res) => {
        let infoList = res?.data?.data?.children || []
        infoList.map((i) => {
          i.children.unshift({ code: 0, text: "不限" })
        })
        this.deviceList[0].list = infoList
      })
    },
    gatLog() {
      this.$api.gatewayLog({ extSrc: this.extSrc }).then((res) => {})
    },
    onBlurValue(e) {
      let value = Number(e.target._value)
      this.changeValue = value ? Math.round(value) : "" //四舍五入（小数部分）
    },
    onBlurBudget(e) {
      let value = Number(e.target._value)
      this.budget = value ? Math.round(value) : "" //四舍五入（小数部分）
    },
    onFinish(selectedOptions) {
      this.infoShow = false
      this.searchVal = ""
      this.infoData = selectedOptions.map((option) => option.text).join("/")
      selectedOptions.map((item, index) => {
        if (index == 0) {
          this.typeName = item.text
          this.typeId = item.code
          this.changeValue = ""
          this.subTypeName = ""
          if (this.typeId == 47 || this.typeId == 49) {
            this.changeLable = "吨位"
            this.changeUnit = "吨"
          } else if (this.typeId == 50) {
            this.changeLable = "臂架长度"
            this.changeUnit = "米"
          } else if (this.typeId == 51 || this.typeId == 52) {
            this.changeLable = "出口压力"
            this.changeUnit = "Mpa"
          } else if (this.typeId == 53) {
            this.changeLable = "装载方量"
            this.changeUnit = "方"
          } else if (this.typeId == 54) {
            this.changeLable = "起重总量"
            this.changeUnit = "吨"
          }
        } else {
          this.brandName = item.text
          this.brandId = item.code
        }
      })
    },
    onConfirmHour(value) {
      this.workHoursName = value
      this.hoursShow = false
    },
    onConfirmYear(value) {
      this.manufactureYearLimit = value
      this.yearShow = false
    },
    onConfirmSubType(value) {
      this.subTypeName = value
      this.subTypeShow = false
    },
    onConfirmTime(value) {
      this.expectPurchaseTime = value
      this.timeShow = false
    },
    onCustomer() {
      window.location.href = "tel:15761021365"
    },
    onClueAdd() {
      let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      let userReg = /\/|\~|\!|\@|\#|\$|\%|\^|\&|\*|\/|\'|\|-|\=|\|\s+/
      if (this.infoData == "") {
        this.$toast({ message: "请选择设备信息", position: "bottom" })
        return
      }
      if (this.typeId == 54 && this.subTypeName == "") {
        this.$toast({ message: "请选择起重机类型", position: "bottom" })
        return
      }
      if (this.typeId != 55 && this.changeValue == "") {
        this.$toast({
          message:
            this.typeId == 50
              ? "请填写臂架长度"
              : this.typeId == 51 || this.typeId == 52
              ? "请填写出口压力"
              : this.typeId == 53
              ? "请填写装载方量"
              : this.typeId == 54
              ? "请填写起重总量"
              : "请填写吨位",
          position: "bottom"
        })
        return
      }
      if (this.expectPurchaseTime == "") {
        this.$toast({ message: "请填写预期购买时间", position: "bottom" })
        return
      }
      if (this.userPhone == "") {
        this.$toast({ message: "请填写联系方式", position: "bottom" })
        return
      }
      if (userReg.test(this.userName)) {
        this.$toast({ message: "姓名不能包含特殊字符", position: "bottom" })
        return
      }
      if (!phoneReg.test(this.userPhone)) {
        this.$toast({ message: "请输入正确的手机号", position: "bottom" })
        return
      }
      let params = {
        extSrc: this.extSrc, //渠道来源
        clueType: 1, //1我要买车
        typeName: this.typeName, //类型名称
        typeId: this.typeId, //类型ID
        brandName: this.brandName, //品牌名称
        brandId: this.brandId, //品牌ID
        workHoursName:
          this.workHoursName == "2000小时以内" ? "workingHours_2000" : this.workHoursName == "5000小时以内" ? "workingHours_5000" : "不限", //工时要求
        manufactureYearLimit: this.manufactureYearLimit, //年限要求
        budget: new BigNumber(this.budget).multipliedBy(1000000).toNumber(), //预算
        expectPurchaseTime:
          this.expectPurchaseTime == "1周内" ? 7 : this.expectPurchaseTime == "1个月内" ? 30 : this.expectPurchaseTime == "3个月内" ? 90 : 180, //预期购买时间
        otherRequire: this.otherRequire, //其他购车要求
        userName: this.userName, //姓名
        userPhone: this.userPhone //联系方式
      }
      if (this.typeId == 47 || this.typeId == 49) {
        params = Object.assign(params, { tonnage: this.changeValue })
      } else if (this.typeId == 50) {
        params = Object.assign(params, { armSpan: this.changeValue })
      } else if (this.typeId == 51 || this.typeId == 52) {
        params = Object.assign(params, { exportPressure: this.changeValue })
      } else if (this.typeId == 53) {
        params = Object.assign(params, { loadCapacity: this.changeValue })
      } else if (this.typeId == 54) {
        params = Object.assign(params, { tonnage: this.changeValue, subTypeName: this.subTypeName })
      }
      if (!this.canClick) return
      this.canClick = false
      this.$api.clueAddBuyOrSale({ ...params }).then((res) => {
        if (res.data.code == 0) {
          this.$toast({ message: "提交成功~", position: "bottom" })
          this.addLottery() //添加号码到抽奖池
        } else {
          this.canClick = true
        }
      })
    },
    addLottery() {
      const params = {
        userName: this.userName,
        userPhone: this.userPhone,
        // phoneVerifyCode: "66668888",
        lotteryActivityId: 2
      }
      this.$api.addLottery({ ...params }).then((res) => {
        if (res.data.code == 0) {
          setTimeout(() => {
            this.$router.push({ path: "/raffle", query: { userPhone: this.userPhone } })
          }, 1500)
          this.canClick = true
        } else {
          this.$toast({ message: res.data.msg, position: "bottom" })
          this.canClick = true
          this.onReset()
        }
      })
    },
    onReset() {
      this.infoData = ""
      this.typeName = ""
      this.typeId = ""
      this.brandName = ""
      this.brandId = ""
      this.subTypeName = ""
      this.changeValue = ""
      this.workHoursName = ""
      this.manufactureYearLimit = ""
      this.budget = ""
      this.expectPurchaseTime = ""
      this.otherRequire = ""
    },
    changeTabs() {
      this.searchVal = ""
    },
    chooseType(item, index) {
      this.deviceList[index].label = item.text
      this.deviceList[index].text = item.text
      this.deviceList[index].code = item.code
      this.resultList[index] = {
        text: item.text,
        code: item.code
      }
      if (index < this.resultList.length - 1) {
        this.resultList.splice(index + 1)
      }
      if (index < this.deviceList.length - 1) {
        for (let j = index + 1; j < this.deviceList.length; j++) {
          this.deviceList[j].label = "请选择"
          this.deviceList[j].text = ""
          this.deviceList[j].code = ""
          this.deviceList[j].list = []
        }
        if (item.children) {
          this.deviceList[index + 1].list = item.children
          this.searchVal = ""
          setTimeout(() => {
            this.active++
          }, 0)
        } else {
          this.onFinish(this.resultList)
        }
      } else {
        this.onFinish(this.resultList)
      }
    }
  },
  watch: {
    screenHeight(val) {
      if (this.originHeight > val + 100) {
        this.showFooter = false
      } else {
        this.showFooter = true
      }
    }
  }
}
</script>
<style lang="scss">
.clueCollect {
  .van-cell {
    background: #ffffff;
    margin-top: 0;
  }
  .van-cell__title {
    flex: 0.5;
  }
  .van-field__label {
    color: #323233;
  }
  .van-cell__value {
    color: #c2c3c4;
  }
  .van-cell__right-icon {
    color: #c2c3c4;
  }
  .selected {
    color: #323233;
  }
}
</style>
<style lang="scss" scoped>
.clueCollect {
  width: 375px;
  height: 100%;
  background: #ff0000;
  .clue-container {
    background: url("https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/clue/raffle-bg1.png") no-repeat;
    background-size: 375px 529px;
    padding: 0 17px 96px 17px;
    box-sizing: border-box;
    padding-top: 280px;
    .clue-title {
      background: #fff7e2;
      border-radius: 15px 15px 0 0;
      text-align: center;
      padding: 6px 0;
      overflow: hidden;
      .clue-title-t {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }
      .clue-title-b {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ed3400;
        line-height: 20px;
        margin-top: 3px;
      }
    }
    .content-region {
      background: #ffffff;
      border-bottom-left-radius: 15px;
      border-bottom-right-radius: 15px;
      margin-top: -2px;
      padding: 10px 0;
      overflow: hidden;
    }
  }
  .bottom-btn-style {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    .btn-style {
      width: 50%;
      height: 80px;
      background: #fff;
      display: block;
    }
  }
  .img-block {
    display: block;
  }
  .img-src {
    display: block;
    margin-top: 20px;
  }
  .device-title {
    padding: 20px;
    font-size: 16px;
  }
  .list-item {
    font-size: 14px;
    padding: 12px 20px;
    box-sizing: border-box;
  }
  .list-item-selected {
    color: red;
  }
  .list-search {
    padding: 0 20px;
    box-sizing: border-box;
  }
  .list-search .van-cell {
    background: #f7f8fa;
    padding-top: 8px;
  }
}
</style>
